import React, { FC, useCallback, useEffect, useState, useContext, useRef } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';
import {get, post} from "../fetchers/fetchers";

import {useParams} from "react-router";
 
import {
    Chip,
    Container,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from "@material-ui/core";
import {IAssessmentSettings, ICriticalHazards, IDocument, IFailureModeAssessment, IHarm, IProjectFailureMode} from "../types/types";
import FailureMode from "./critical_failure_mode";
import FailureModesSelect from "./failure_mode";
import { APPLICATION } from "../env";
import { API_URL } from "../env";
import {getFailureModeAssessments} from "../stateManagement/data";

interface ICriticalHazardsProps {
}

interface IRouteParams {
    id: string
}






const CriticalHazards: FC<ICriticalHazardsProps> = () => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    const [write_access, setWriteAccess] = useState<boolean>(false);

    const [isLoaded, setIsLoaded] = useState<boolean>(true);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [riskAssessments, setRiskAssessments] = useState<ICriticalHazards[]>([]);
    const [failureModeAssessments, setFailureModeAssessments]= useState<IFailureModeAssessment[]>([]);
    const [assessmentSettings, setAssessmentSettings] = useState<IAssessmentSettings>();

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])

    useEffect(() => {

        if (tasks.loaded) {
            setFailureModes(tasks.failureModes)
            setFailureModeAssessments(tasks.failureModeAssessments)
            setRiskAssessments(tasks.criticalHazards)
            setAssessmentSettings(tasks.assessmentSettings)
        }

    })

    const params = useParams<IRouteParams>()


    const postFailureModeAssessment = async (failure_mode_assessment:IFailureModeAssessment) => {
        delete failure_mode_assessment.id
        delete failure_mode_assessment.assessment_project_id

        // console.log('these is the failure mode assessment: ',failure_mode_assessment)

        const assessments = await post<IFailureModeAssessment>( API_URL + "failure_modes/" + params.id +"/assessment", failure_mode_assessment);
        let e =await getFailureModeAssessments( params.id, dispatch)

    }


    const getInitialRiskAssessment = (project_failure_mode_id: number) : ICriticalHazards => {
        let risk_assessments = riskAssessments?.find( a => (a.project_failure_mode_id === project_failure_mode_id ))


        if (risk_assessments) {
            return risk_assessments;

        }
        //
        return {
            project_failure_mode_id: 0,
            max_annual_failure_probability : 0,
            max_societal_risk : 0,
            sum_societal_risk : 0,
            max_individual_risk : 0,
            contribution_to_societal_risk: 0,
            contribution_to_individual_risk: 0,
            critical: false,
            societal_confidence_id : 0,
            individual_confidence_id: 0

        }
    }

    const updateFailureModeAssessment = useCallback((failure_mode_assessment: IFailureModeAssessment) => {
        postFailureModeAssessment(failure_mode_assessment).then( () => {
                setIsLoaded(false)
            }
        )
    }, [postFailureModeAssessment, setIsLoaded]);

    const getInitialFailureModeAssessment = (project_failure_mode_id: number) : IFailureModeAssessment => {
        let failure_mode_assessment = failureModeAssessments.find(
            a => (a.project_failure_mode_id === project_failure_mode_id))

        if (failure_mode_assessment) {
            return failure_mode_assessment;

        }
        return {
            project_failure_mode_id: project_failure_mode_id
        }
    }

    // check if task is not loaded return loading message
    if (!tasks.loaded || !assessmentSettings || !failureModes || !riskAssessments || !failureModeAssessments) {
        return (
            <Container style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px" }}>
                <Typography variant="h6">Loading Critical Hazards...</Typography>
            </Container>
        );
    }


    return (
        <TableContainer style={{ maxHeight: "80vh",  overflowX: "auto", maxWidth: "100%" }}>
        <Table stickyHeader={true}>
            <TableHead>
                <TableCell></TableCell>
                <TableCell>Failure Mode</TableCell>
                <TableCell>Annual Failure Probability</TableCell>
                <TableCell>Societal Risk</TableCell>
                <TableCell>Contribution to Total Risk (%)</TableCell>
                <TableCell>Individual Risk</TableCell>
                <TableCell>Contribution to Individual Risk (%)</TableCell>
                <TableCell>
                    Potential for Risk to Increase
                </TableCell>

                {APPLICATION === "SFAIRP" && <TableCell>Critical Automatic</TableCell> }
                {APPLICATION === "ALARP" && <TableCell>Priority Automatic</TableCell> }

                {APPLICATION === "SFAIRP" && <TableCell>Included</TableCell> }
                {APPLICATION === "ALARP" && <TableCell>Priority</TableCell> }

                <TableCell>Societal Risk Confidence</TableCell>
                <TableCell>Individual Risk Confidence</TableCell>
                <TableCell>Comments</TableCell>
            </TableHead>
            {failureModes.map( (f) => {
                if (f.failure_mode?.is_active === false) { return <></> }
                if (!f.id) {
                    return (<></>)
                }


                return (
                    <FailureMode failure_mode={f}
                                 risk_assessment={getInitialRiskAssessment(f.id)}
                                 initial_failure_mode_assessment={getInitialFailureModeAssessment(f.id)}
                                 settings={assessmentSettings}
                                 updateFailureModeAssessment={updateFailureModeAssessment}
                                 />
                )
            })}
        </Table>
        </TableContainer>
    );
}

export default CriticalHazards;

